import { useAppSelector } from "app/hooks";
import { selectLoaded, selectUser } from "features/auth/authSlice";
import { UserRole } from "features/auth/types/user";
import PendingApproval from "pages/pendingApproval/PendingApproval";
import VerifyEmail from "pages/verifyEmail/VerifyEmail";
import { Navigate } from "react-router";

export interface IAuthRouteProps {
  notApprovedComponent?: React.ReactNode;
  authorizedRoles?: UserRole[];
}

const PendingVerificationRoute: React.FunctionComponent<IAuthRouteProps> = (
  props
) => {
  const { authorizedRoles } = props;
  const authIsLoaded = useAppSelector(selectLoaded);
  const user = useAppSelector(selectUser);
  const userIsUnVerified = user?.state === "CREATED";
  const userIsNotApproved = user?.state === "PENDING";

  const hasPermission = (): boolean => {
    if (!authorizedRoles) {
      return true;
    } else {
      return authorizedRoles.includes(user?.role ? user?.role : UserRole.NONE);
    }
  };

  if (authIsLoaded) {
    if (!user) {
      return <Navigate to="/login" />;
    } else if (userIsUnVerified) {
      //return <Navigate to="/verify" />;
      return <VerifyEmail />;
    } else if (userIsNotApproved) {
      //return <Navigate to="/pendingapproval" />;
      return <PendingApproval />;
    } else {
      return <Navigate to="/" />;
    }

    // else if (hasPermission()) {
    //   return <>{children}</>;
    // }
  } else {
    return <></>;
  }
};

export default PendingVerificationRoute;
